type InfoCardProps = {
  className?: string;
  disabled?: boolean;
};

const InfoCard: React.FC<InfoCardProps> = ({ children, className = '', disabled = false }) => <div className={`bg-secondary rounded p-3 ${className}`}>{children}</div>;
export default InfoCard;
